import { render, staticRenderFns } from "./newSupplier.vue?vue&type=template&id=994cf7e6&scoped=true&"
import script from "./newSupplier.vue?vue&type=script&lang=js&"
export * from "./newSupplier.vue?vue&type=script&lang=js&"
import style0 from "./newSupplier.vue?vue&type=style&index=0&id=994cf7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994cf7e6",
  null
  
)

export default component.exports